import { useMemo } from 'react'
import { useIntakeFlow } from '../providers/IntakeFlowProvider'

const useGetRequiredActionWorkflowBlocks = () => {
  const { workflow } = useIntakeFlow()
  return useMemo(() => workflow?.active_blocks || [], [workflow])
}

export default useGetRequiredActionWorkflowBlocks
